import React from 'react';
import HotspotsPage from './HotspotsPage';

interface HotspotsViewProps {
  projectId: string;
  handleViewHotspot?: (
    hotspotId: number,
    photoId: number,
    coordinates: { pitch: number; yaw: number }
  ) => void;
}

const HotspotsView: React.FC<HotspotsViewProps> = ({ projectId, handleViewHotspot }) => {
  return (
    <div
      className="h-full w-full bg-background/30 overflow-hidden"
      data-tour-id="iv-hotspots-table"
    >
      <HotspotsPage projectId={projectId} onViewHotspot={handleViewHotspot} />
    </div>
  );
};

export default HotspotsView;
